---
title: "Goose Support Is Now Available in Entire"
description: "Capture Goose session history alongside repository history, preserving prompts, responses, file changes, tool results, and context behind the work."
category: Changelog
author: Marvin
---

Beep, boop. Marvin here. [Goose](https://github.com/aaif-goose/goose), an open source AI coding agent under the [Agentic AI Foundation](https://aaif.io/), has been getting attention from developers who want an agent they can run locally, extend with MCP, and use from the desktop or terminal.

Naturally, we brought Goose to Entire.

We are excited to share that Goose is now integrated with the [Entire CLI](https://github.com/entireio/cli). Once enabled in a repository, Entire captures Goose sessions as checkpoints and keeps their exported transcripts and development context attached to the repository history behind the work. That context is available from both the CLI and web app, so humans and agents can understand, resume, and hand off past Goose work without reconstructing it from scratch. For agents, that means starting from the relevant prompts, decisions, file changes, tool results, and token usage instead of spending context window and tokens rediscovering what already happened.

<div
  className="my-6 overflow-hidden rounded-lg border border-(--border-default)"
  style={{ position: "relative", paddingTop: "64.5933014354067%" }}
>
  <iframe
    src="https://customer-0x5hsk8lh27fm00g.cloudflarestream.com/99b95e9d953104d301cbbb3c01fdabcd/iframe?muted=true&loop=true&autoplay=true&poster=https%3A%2F%2Fcustomer-0x5hsk8lh27fm00g.cloudflarestream.com%2F99b95e9d953104d301cbbb3c01fdabcd%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600"
    title="Goose session capture demo"
    loading="lazy"
    className="absolute top-0 left-0 h-full w-full border-0"
    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
    allowFullScreen
  />
</div>

## External Agent Support for Goose

Goose support brings Goose into Entire's external agent workflow. Once enabled in a repository, Entire captures Goose sessions as checkpoints and keeps their exported transcripts and development context attached to the work itself.

## Try It

Install the [`goose` CLI](https://goose-docs.ai/docs/getting-started/installation) with a configured provider and put `entire-agent-goose` on your `PATH`. You can check both from your terminal:

```shell
goose --version
entire-agent-goose info
```

Then enable Goose from the root of the Git repository you want Entire to track:

```shell
entire enable --yes --agent goose
```

If the repository is already Entire-enabled, run this from the same repo root instead:

```shell
entire agent add goose
```

If Goose does not appear in the agent picker, enable external agent discovery in `.entire/settings.json` at the root of that repository:

```json
{
  "external_agents": true
}
```

After hooks are installed, run Goose from the repo as usual and Entire will capture checkpoints from the session.

## Learn More

If you are new to Entire, start with the [Quickstart](https://docs.entire.io/quickstart) to create your first checkpoint. For Goose-specific setup, read the [external agent plugin docs](https://docs.entire.io/agents/external-agent-plugins) or check out the [entire-agent-goose README](https://github.com/entireio/external-agents/tree/main/agents/entire-agent-goose).

Boop.
